import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { defaultShouldDehydrateQuery, QueryClient } from '@tanstack/react-query';
import type { PersistQueryClientProviderProps } from '@tanstack/react-query-persist-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      refetchOnWindowFocus: false,
      refetchOnMount: 'always',
      gcTime: Infinity,
      networkMode: 'offlineFirst',
    },
  },
});

const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

const persistentQueries = ['TIME_SERIES', 'SYMBOLS', 'WATCH_LIST', 'ACCOUNT', 'TRANSACTIONS', 'RECORDS'];

export const persistOptions: PersistQueryClientProviderProps['persistOptions'] = {
  persister,
  maxAge: Infinity,
  dehydrateOptions: {
    shouldDehydrateQuery: (query) =>
      defaultShouldDehydrateQuery(query) && persistentQueries.some((key) => query.queryKey.includes(key)),
  },
};
